<template>
  <div class="card-visit-shop-detail">
    <section>
      <VisitShopDetailHeader :bpDetail="bpDetail" />
    </section>
    <hr />
    <section>
      <VisitShopDetailStatus :bpDetail="bpDetail" />
    </section>
    <hr />
    <section>
      <VisitShopDetailTotal :bpDetail="bpDetail" />
    </section>
    <hr />
    <section>
      <VisitShopDetailTotalMonth :bpDetail="bpDetail" />
    </section>
    <hr />
    <section>
      <VisitShopDetailTotalTable :ScgBPNumber="bpDetail.ScgBPNumber" />
    </section>
  </div>
</template>

<script>
import VisitShopDetailHeader from './VisitShopDetailHeader.vue'
import VisitShopDetailStatus from './VisitShopDetailStatus.vue'
import VisitShopDetailTotal from './VisitShopDetailTotal.vue'
import VisitShopDetailTotalMonth from './VisitShopDetailTotalMonth.vue'
import VisitShopDetailTotalTable from './VisitShopDetailTotalTable.vue'

export default {
  props: {
    bpDetail: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VisitShopDetailHeader,
    VisitShopDetailStatus,
    VisitShopDetailTotal,
    VisitShopDetailTotalMonth,
    VisitShopDetailTotalTable,
  },
}
</script>

<style lang="scss" scoped>
.card-visit-shop-detail {
  border-radius: 8px;
  background-color: #ffffff;
  padding: 10px 30px;
  margin: 20px;
}
</style>
